<template>
  <div class='item'>
    <p class='content' @click='newsDetail'>
      <span class='title'>{{ info.noticeTitle }}</span><span class='date'> {{info.createTime | DateFilter }} </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  methods: {
    newsDetail() {
      this.$router.push({ path: `/navigator/notifications/detail/${this.info.noticeId}` });
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
  .item{
    &:last-of-type{
      margin-bottom: 0;
    }
    .content{
      @include clear-float;
      cursor: pointer;
      line-height: 60px;
      padding: 0 40px;
      border-bottom: 1px solid #f5f5f5;
      .title{
        float: left;
        font-size: 20px;
        color: #333;
        width: 1000px;
        @include line-ellipsis;
      }
      .date{
        font-size: 16px;
        color: #333;
        float: right;
      }
    }
    .content:hover{
      color: #999999;
      .date{
        color: #999999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/navigator/notifications/components/child/Item.vue